// extracted by mini-css-extract-plugin
export default {"Logo__new_year":"Logo_Logo__new_year__2TVJ6","Logo":"Logo_Logo__3ji6S"};